<template>
    <!-- <div class="pageFixedMenu">
		<a><img src="/static/images/web/phone.png">
			<p class="code"><img src="/static/images/web/d-app.png" alt=""></p>
		</a>
		<a><img src="/static/images/web/wechat.png">
			<p class="code"><img src="/static/images/web/d-wechat.png" alt=""></p>
		</a>
	</div> -->
	<div class="all-right" id="all-right">
		<!-- <a>
			<p><span class="icon">&#xe8b4;</span></p>
			<p class="txt">在线<br>咨询</p>
		</a> -->
		<!-- <a>
			<p><span class="icon">&#xe6c7;</span></p>
			<p class="txt">下载<br>APP</p>
			<p class="code"><img src="/static/images/common/d-app.png" alt=""></p>
		</a>
		<a>
			<p><span class="icon">&#xe63e;</span></p>
			<p class="txt">微信<br>关注</p>
			<p class="code"><img src="/static/images/common/wechat.jpg" alt=""></p>
		</a> -->
		<a v-if="$store.state.common.info.posterName">
			<p><span class="icon">&#xe6b4;</span></p>
			<p class="txt">我的<br>订单</p>
			<div class="code">
				<div class="page-sider-menu">
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/order')">企业团体雇主责任险</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/order?product=TRUCK_EMPLOYERS_LIABILITY_INSURANCE')">货车雇主责任险</p>
					<p class="page-sider-item" @click="toPage('/haier.html#/my/order')">海尔经销商防控计划</p>
					<p class="page-sider-item" @click="toPage('/agent.html#/agent/my/task')" v-if="$store.state.common.info.isInHaier">原保代产品</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customized/task?product')" >建工产品</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customizedCCIC/order')" >行业小微人资产品</p>
				</div>
			</div>
		</a>
		<a v-if="$store.state.common.info.posterName">
			<p><span class="icon">&#xe6f5;</span></p>
			<p class="txt">我的<br>保单</p>
			<div class="code">
				<div class="page-sider-menu">
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/policy')">企业团体雇主责任险</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/policy?product=TRUCK_EMPLOYERS_LIABILITY_INSURANCE')">货车雇主责任险</p>
					<p class="page-sider-item" @click="toPage('/haier.html#/my/policy')">海尔经销商防控计划</p>
					<p class="page-sider-item" @click="toPage('/agent.html#/agent/my/policy')" v-if="$store.state.common.info.isInHaier">原保代产品</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customized/policy')" >建工产品</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customizedCCIC/policy')" >行业小微人资产品</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customizedTPL/policy')" >特种设备责任险</p>
					<p class="page-sider-item" @click="toPage('/haierProduct.html#/my/customizedLineWork/policy')">同线工人雇主责任险</p>
				</div>
			</div>
		</a>
		<a>
			<p><span class="icon">&#xe6c7;</span></p>
			<p class="txt">手机<br>全掌柜</p>
			<div class="code">
				<img src="/static/images/common/d-app.png" alt="" />
				<img style="width: 179px;transform:translateY(-16px) translateX(-1.5px);" src="/static/images/common/wechat.jpg" alt="" />
				<p class="iconText">微信公众号</p>
			</div>
		</a>
		<a id="toTop">
			<!-- <p><i class="iconfont icon-zhiding"></i></p> -->
			<p><span class="icon">&#xe69d;</span></p>
			<p class="txt">回到<br>顶部</p>
		</a>
	</div>
</template>
<script>
import $ from 'jquery'
import mixin from '@/mixin/store'
export default {
  	mixins: [mixin],
    data(){
        return {
        }
    },
    mounted(){
		let that = this
		$(document).ready(function() {
			var ScrolltoTop = $("#all-right");
			var ScrolltoTopBtn = $("#toTop");
			console.log(that.$store.state.common.info.posterName)
			if(!that.$store.state.common.info.posterName){
				$(ScrolltoTop).hide();
			}
			$(window).scroll(function() {
				if ($(window).scrollTop() == "0" && !that.$store.state.common.info.posterName) {
					$(ScrolltoTop).fadeOut("slow")
				} else {
					$(ScrolltoTop).fadeIn("slow")
				}
			});
			$(ScrolltoTopBtn).click(function() {
				$('html, body').animate({
					scrollTop: 0
				},
				400)
			})
		});
    },
    methods:{
		toPage(url){
			if (url=='/index')url='/';
			window.open(url)
		}
    }
}
</script>
<style scoped lang="less">
.all-right{
	position: fixed;
	right: 10px;
	bottom: 25%;
	margin-top: -40px;
	z-index: 99999;
	box-shadow: 0px 0px 10px 0px 
		rgba(1, 1, 1, 0.1);
	border-radius: 5px;
}
.all-right>a{
	display: block;
	background: #fff;
	width: 60px;
	height: 95px;
	text-align: center;
	padding-top: 5px;
	cursor: pointer;
	position: relative;
	color: #8c8c8c;
	font-size: 16px;
}
.all-right p.txt{
	font-size: 12px;
}
.all-right p i{
	font-size: 30px;
}
.all-right p span.icon{
	font-size: 30px;
}
.all-right>a:hover{
	background: #2768ef;
	color: #fff;
}
.all-right>a:first-child{
	border-bottom: 1px solid #fff;
}
.all-right>a>div.code img{
	width: 200px;
}
.all-right>a>div.code{
	position: absolute;
	top: -8px;
	right: 60px;
	-webkit-transform:scale(0);
	transform:scale(0);
	-webkit-transition: all .2s;
	transition: all .2s;
	-webkit-transform-origin: 100% 5%;
	transform-origin: 100% 5%;
}
.all-right>a:hover>div.code{
	-webkit-transform:scale(1);
	transform:scale(1);
}
.all-right>a>div.code p.iconText{
	width: 178px;
	background-color: #fff;
	text-align: center;
    font-size: 16px;
    font-weight: 500;
	color: #666;
	padding: 5px 0;
    transform: translateY(-22px);
    margin-left: 10px;
}
.page-sider-menu{
	width: 200px;
	background-color: #fff;
	color: rgb(101, 113, 128);
	text-align: left;
	padding: 5px 0;
}
.page-sider-item{
	cursor: pointer;
	padding: 6px 20px;
}
.page-sider-item:hover{
	background-color: rgb(243, 243, 243);
}
// .pageFixedMenu{
//     position: fixed;
//     right: 0;
//     top: 50%;
//     margin-top: -40px;
//     >a{
//         display: block;
//         background: #939393;
//         width: 40px;
//         height: 40px;
//         text-align: center;
//         padding-top: 5px;
//         cursor: pointer;
//         position: relative;
//         &:hover{
//             background: #626262;
//         }
//         &:first-child {
//             border-bottom: 1px solid #fff;
//         }
//         .code{
//             position: absolute;
//             top: -8px;
//             right: 45px;
//             -webkit-transform: scale(0);
//             transform: scale(0);
//             -webkit-transition: all .2s;
//             transition: all .2s;
//             -webkit-transform-origin: 100% 5%;
//             transform-origin: 100% 5%;
//         }
//         &:hover>p.code{
//             -webkit-transform:scale(1);
//             transform:scale(1);
//         }
//     }
// }
</style>


// WEBPACK FOOTER //
// src/components/common/PageFixedMenu.vue